interface UserInfoProps {
  fullName: string;
  email?: string;
  initials: string;
}

export const UserInfo = ({ fullName, email, initials }: UserInfoProps) => (
  <>
    <div>
      <div className="text-default text-sm font-medium">{fullName}</div>
      <div className="text-light text-sm">{email}</div>
    </div>
    <div className="bg-tertiary text-default flex h-10 w-10 items-center justify-center overflow-hidden rounded-full text-sm font-medium">
      {initials}
    </div>
  </>
);
